import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Chip,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { DischargeReferralDocument, DischargeDocType } from './buildReferralPacket';

const TYPE_LABELS: Record<DischargeDocType, string> = {
  discharge_summary: 'Discharge Summary',
  pt_ot_notes: 'PT/OT Notes',
  wound_notes: 'Wound Care Notes',
  physician_orders: 'Physician Orders',
  insurance_auth: 'Insurance Authorization',
  agency_narrative: 'Agency Narrative',
};

interface Props {
  document: DischargeReferralDocument | null;
  onClose: () => void;
}

const DischargeDocumentPreviewDialog: React.FC<Props> = ({ document, onClose }) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    if (!document) return;
    navigator.clipboard.writeText(document.content);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={!!document} onClose={onClose} maxWidth="md" fullWidth>
      {document && (
        <>
          <DialogTitle sx={{ pb: 1 }}>
            <Typography variant="h6">{document.title}</Typography>
            <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
              <Chip label={TYPE_LABELS[document.type]} size="small" variant="outlined" />
              <Chip label={document.dateCreated} size="small" variant="outlined" />
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <Box
              sx={{
                fontFamily: 'monospace', fontSize: '0.85rem', whiteSpace: 'pre-wrap',
                backgroundColor: 'grey.50', p: 2, borderRadius: 1, lineHeight: 1.6,
              }}
            >
              {document.content}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              startIcon={<ContentCopyIcon />}
              onClick={handleCopy}
              color={copied ? 'success' : 'inherit'}
            >
              {copied ? 'Copied!' : 'Copy to Clipboard'}
            </Button>
            <Button onClick={onClose} variant="contained">Close</Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default DischargeDocumentPreviewDialog;
